import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle } from 'lucide-react';
const testimonials = [{
  quote: 'Después de los 42, pensé que mi metabolismo estaba roto para siempre. En la Fase 1 perdí la hinchazón y en 21 días bajé 2 tallas.',
  name: 'María G.',
  age: '45 años',
  rating: 5,
  image: 'https://images.unsplash.com/photo-1594824476967-48c8b964ac31?w=150&q=80'
}, {
  quote: 'Lo mejor es que no pasé hambre. Los Tacos de Pescado del recetario son increíbles. Mi familia ni notó que estaba en un protocolo.',
  name: 'Carmen L.',
  age: '48 años',
  rating: 5,
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&q=80'
}, {
  quote: 'Mi temperatura basal subió de 35.8 a 36.6 en dos semanas. Por primera vez entendí por qué no podía bajar de peso.',
  name: 'Rosa M.',
  age: '52 años',
  rating: 5,
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&q=80'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-[#064E3B] text-white" data-id="element-187">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188">
        <div className="text-center mb-16" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-190">
            Historias Reales de Mujeres como Tú
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-191">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white text-[#1F2937] p-8 rounded-2xl shadow-xl relative flex flex-col" data-id="element-192">
              <div className="flex text-[#F59E0B] mb-4" data-id="element-193">
                {[...Array(item.rating)].map((_, i) => <Star key={i} size={18} fill="currentColor" className="mr-1" data-id="element-194" />)}
              </div>

              <p className="text-[#4B5563] italic mb-6 text-lg leading-relaxed flex-grow" data-id="element-195">
                "{item.quote}"
              </p>

              <div className="flex items-center justify-between border-t border-gray-100 pt-4 mt-auto" data-id="element-196">
                <div className="flex items-center" data-id="element-197">
                  <img src={item.image} alt={item.name} className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-[#ECFDF5]" data-id="element-198" />
                  <div data-id="element-199">
                    <p className="font-bold text-[#0D6B4F]" data-id="element-200">{item.name}</p>
                    <p className="text-xs text-gray-500" data-id="element-201">{item.age}</p>
                  </div>
                </div>
                <div className="flex items-center text-[#10B981] text-xs font-bold bg-[#ECFDF5] px-2 py-1 rounded-full self-start mt-2" data-id="element-202">
                  <CheckCircle size={12} className="mr-1" data-id="element-203" />
                  Verificado
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}